export default "__VITE_ASSET__DkCjP7Vf__"